export const STEP_FIND_YOUR_BUSINESS = 'find-your-business';
export const STEP_SITE_BUILDER = 'site-builder';
export const STEP_GENERATING_WEBSITE = 'generating-website';
export const STEP_PURCHASE_INFORMATION = 'purchase-information';
export const STEP_CATEGORY_KEYWORDS = 'category-keywords';
export const STEP_DESIGN = 'design';
export const STEP_SOCIAL_MEDIA = 'social-media';
export const STEP_PREPARING_WEBSITE = 'preparing-website';

// groups names
export const GROUP_DEFAULT = 'Default';
export const WIZARD_STEPS_GROUPS = [GROUP_DEFAULT];
